import { apiClient } from 'services/api-client';
import { PaginatedResponse, toPaginatedResponse } from 'dtos/common/api.dto';

export interface Member {
  id: string;
  full_name: string;
  email: string;
  role: 'owner' | 'manager' | 'associate';
  created_at: string;
  store_ids: string[];
}

export interface Invitation {
  id: string;
  email: string;
  role: 'manager' | 'associate';
  created_at: string;
  expires_at: string;
  store_ids: string[];
}

export class MemberService {
  static async listMembers(orgId: string, page = 1, pageSize = 8): Promise<PaginatedResponse<Member>> {
    const response = await apiClient.get<Member[]>(`/orgs/${orgId}/members?page=${page}&pageSize=${pageSize}`);
    return toPaginatedResponse(response, page, pageSize);
  }

  static async listInvitations(orgId: string, page = 1, pageSize = 8): Promise<PaginatedResponse<Invitation>> {
    const response = await apiClient.get<Invitation[]>(`/orgs/${orgId}/invitations?page=${page}&pageSize=${pageSize}`);
    return toPaginatedResponse(response, page, pageSize);
  }

  static async invite(orgId: string, email: string, role: 'manager' | 'associate', storeIds: string[]): Promise<Invitation> {
    const response = await apiClient.post<{ invitation: Invitation }>(`/orgs/${orgId}/invitations`, { email, role, store_ids: storeIds });
    return response.data.invitation;
  }

  static async revokeInvitation(orgId: string, invitationId: string): Promise<void> {
    await apiClient.delete(`/orgs/${orgId}/invitations/${invitationId}`);
  }

  static async updateRole(orgId: string, memberId: string, role: 'manager' | 'associate'): Promise<void> {
    await apiClient.patch(`/orgs/${orgId}/members/${memberId}`, { role });
  }

  static async remove(orgId: string, memberId: string): Promise<void> {
    await apiClient.delete(`/orgs/${orgId}/members/${memberId}`);
  }
}
